const { BROKER_CONNECTIONS_ROUTE, SITE_BASE_URL } = require('./brokerConnectionSource');
const { publicPositioningPages } = require('./comparisonContent');

const CORE_PUBLIC_SITE_ROUTES = [
  {
    path: '/',
    title: 'AI Trading Bot Builder & Backtesting Platform | BotSpot',
    description: 'Turn your trading rules into a testable system. Build with AI, inspect historical evidence, and connect your broker with BotSpot.',
  },
  {
    path: '/sales',
    title: 'Build AI Trading Bots in Minutes | BotSpot',
    description: 'Build, backtest, and deploy automated trading strategies with AI. Start without coding and connect your existing brokerage account.',
  },
  {
    path: '/marketplace',
    title: 'Algorithm Marketplace: AI Trading Strategies | BotSpot',
    description: 'Browse public trading strategies with live history and backtest results, then clone a strategy and customize it in BotSpot.',
  },
  {
    path: '/sales-marketplace',
    title: 'Find an Automated Trading Strategy | BotSpot',
    description: 'Explore ready-to-run trading strategies, review performance data, and choose a bot to customize and deploy through BotSpot.',
  },
  {
    path: '/pricing',
    title: 'AI Trading Bot Pricing & Plans | BotSpot',
    description: 'Compare BotSpot plans for AI strategy building, backtesting, live bots, broker connections, support, and trading education.',
  },
  {
    path: '/enterprise',
    title: 'AI Solutions for Investment Firms | BotSpot',
    description: 'Diagnostic-led AI implementation for investment-firm growth, research, and senior-team capacity.',
  },
  {
    path: '/agents',
    title: 'AI Trading Agents for ChatGPT, Claude & Cursor | BotSpot',
    description: 'Connect BotSpot to ChatGPT, Claude, Cursor, and MCP clients to research strategies, run backtests, and manage trading workflows.',
  },
  {
    path: '/case-studies',
    title: 'Algorithmic Trading Case Studies | BotSpot',
    description: 'Explore complex backtests and practical examples of AI-assisted algorithmic trading workflows built with BotSpot.',
  },
  {
    path: '/ai-bot-builder-bootcamp',
    title: 'AI Investing & Trading Bot Bootcamp | BotSpot',
    description: 'Build practical AI investing workflows through live instruction, projects, Q&A, recordings, and hands-on BotSpot access.',
  },
  {
    path: '/ai-bot-builder-bootcamp/self-paced',
    title: 'Self-Paced AI Trading Bootcamp | BotSpot',
    description: 'Learn AI-assisted investing and trading workflows on your schedule with recordings, projects, resources, and BotSpot access.',
  },
  {
    path: '/live-algo-lab',
    title: 'Live Algorithmic Trading Lab | BotSpot',
    description: 'Join live weekly sessions covering real BotSpot workflows, algorithmic trading builds, strategy reviews, and implementation Q&A.',
  },
  {
    path: '/upgrade-to-pro',
    title: 'BotSpot Pro: More Bots, Backtests & Support',
    description: 'Upgrade BotSpot for higher strategy revision limits, more live bots, additional backtesting capacity, and priority support.',
  },
  {
    path: '/help',
    title: 'BotSpot Help & Support',
    description: 'Find BotSpot setup guidance, product help, broker connection information, and support resources.',
  },
  {
    path: '/terms',
    title: 'Terms of Service | BotSpot',
    description: 'Read BotSpot terms covering platform use, broker connections, marketplace content, AI outputs, fees, and trading risk.',
  },
  {
    path: '/privacy',
    title: 'Privacy Policy | BotSpot',
    description: 'Read how BotSpot collects, uses, protects, and shares information when you use its websites, applications, and services.',
  },
  {
    path: '/blog',
    title: 'AI Trading & Market Automation Blog | BotSpot',
    description: 'Read BotSpot market newsletters, automated trading tutorials, AI strategy guides, and product updates.',
  },
  {
    path: '/blog/using-ai-to-make-ai-profitable-swing-trading-bot-in-seconds',
    title: 'Using AI to Make a Profitable Swing Trading Bot in Seconds',
    description: 'BotSpot blog article about building a swing trading bot with AI.',
  },
];

const PUBLIC_SITE_ROUTES = [
  ...CORE_PUBLIC_SITE_ROUTES,
  ...publicPositioningPages,
];

const APP_SITE_ROUTES = [
  {
    path: BROKER_CONNECTIONS_ROUTE,
    title: 'Broker Connections',
    description: 'Authenticated BotSpot page for connecting, reconnecting, and managing broker credentials.',
    authenticated: true,
    sitemap: false,
    llms: true,
  },
  {
    path: '/ai-agent',
    title: 'BotSpot Agent',
    description: 'Authenticated AI agent workspace for strategy research, building, backtesting, and broker-aware answers.',
    authenticated: true,
    sitemap: false,
    llms: true,
  },
];

module.exports = {
  APP_SITE_ROUTES,
  CORE_PUBLIC_SITE_ROUTES,
  PUBLIC_SITE_ROUTES,
  SITE_BASE_URL,
};
